import {
  getObject,
  getOptionalObject,
  getList,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";
import { GridRowResponseV1, GridRowResponseV1DTO } from "./gridRowResponseV1";

export interface GridQuestionResponseV1DTO {
  columnHeader?: SurveyLocalizedTextDTO | null;
  gridRowResponses: GridRowResponseV1DTO[];
}

export class GridQuestionResponseV1 {
  readonly isGridQuestionResponseV1GridQuestionResponseV1: boolean = true;

  readonly columnHeader: SurveyLocalizedText | null;
  readonly gridRowResponses: GridRowResponseV1[];


  constructor(
  columnHeader: SurveyLocalizedText | null = null, 
  gridRowResponses: GridRowResponseV1[]
  ) {
    this.columnHeader = columnHeader;
    this.gridRowResponses = gridRowResponses;
  }

  static fromDTO(dto: GridQuestionResponseV1DTO): GridQuestionResponseV1 {
    let columnHeader = getOptionalObject(dto, "columnHeader");
    if(columnHeader !== undefined && columnHeader !== null) {
      columnHeader = SurveyLocalizedText.fromDTO(getObject(dto, "columnHeader", InvalidGridQuestionResponseV1ColumnHeaderError));
    }
    const gridRowResponses = getList<GridRowResponseV1DTO, GridRowResponseV1>(
      dto,
      "gridRowResponses",
      GridRowResponseV1.fromDTO,
      InvalidGridQuestionResponseV1GridRowResponsesError
    );
    return new GridQuestionResponseV1(
      columnHeader,
      gridRowResponses
    );
  }

  toDTO(): GridQuestionResponseV1DTO {
    const dto: GridQuestionResponseV1DTO = {
        gridRowResponses: this.gridRowResponses.map((e: GridRowResponseV1) => { return e.toDTO() })
    };
    if (this.columnHeader !== undefined && this.columnHeader !== null){
      dto.columnHeader = this.columnHeader.toDTO();
    }
    return dto;
  }
  }

GridQuestionResponseV1.prototype.toString = function toString(): string {
  return `GridQuestionResponseV1(columnHeader='${this.columnHeader}',gridRowResponses='${this.gridRowResponses}')`;
};

export class InvalidGridQuestionResponseV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridQuestionResponseV1Error";
  }
}
export class InvalidGridQuestionResponseV1ColumnHeaderError extends InvalidGridQuestionResponseV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridQuestionResponseV1ColumnHeaderError";
  }
}

export class InvalidGridQuestionResponseV1GridRowResponsesError extends InvalidGridQuestionResponseV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridQuestionResponseV1GridRowResponsesError";
  }
}
